/**
 * 其他站点 FBA 费率配置
 * 包括: JP, CA
 */
import { SiteConfig } from '../types';

export const JP_CONFIG: SiteConfig = {
    currency: '¥',
    lowPriceThreshold: 1000, // Approx
    storageFees: {
        standard: { jan_sep: 5160, oct_dec: 9170, unit: 'cbm' },
        oversize: { jan_sep: 4370, oct_dec: 7760, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Small (250g)', maxWeight: 0.25, maxEdge: [25, 18, 2], fee: 288, unit: 'g' },
            { tierName: 'Standard 1 (50cm)', maxWeight: 1, maxEdge: [50, 50, 50], fee: 434, unit: 'kg' }, // Simplified edge check
            { tierName: 'Standard 2 (60cm)', maxWeight: 2, maxEdge: [60, 60, 60], fee: 465, unit: 'kg' },
        ],
        lowPrice: [] // JP Low price program specifics vary
    }
};

export const CA_CONFIG: SiteConfig = {
    currency: 'C$',
    lowPriceThreshold: 15.00, // Approx
    storageFees: {
        standard: { jan_sep: 35.00, oct_dec: 55.00, unit: 'cbm' },
        oversize: { jan_sep: 25.00, oct_dec: 40.00, unit: 'cbm' }
    },
    sizeTiers: {
        standard: [
            { tierName: 'Envelope (100g)', maxWeight: 0.1, maxEdge: [38, 27, 2], fee: 3.68, unit: 'g' },
            { tierName: 'Standard (250g)', maxWeight: 0.25, maxEdge: [45, 35, 20], fee: 5.92, unit: 'g' },
        ],
        lowPrice: []
    }
};
